var Model = require('../Model');

var Dataset = Object.create(Model);

Dataset.name = 'Dataset';
Dataset['@class'] = 'Dataset';
Dataset.url = 'dataset';
Dataset.fields = {
  parent: {
    default: null
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 1, maximum: 64, default: ''},
    }
  },
  index: {
    default: null,
  },
  url: {
    default: null
  },
  extendedProps: {
    default : {},
    hidden: true
  },
  type: {
    default: null,
  },
  columns: {
    default: [],
    hidden: true
  },
  visible: {
    default: null,
    hidden: true
  },
  purpose: {
    default: null,
    hidden: true
  },
  isSystem: {
    default: false,
    hidden: true
  },
  width: {
    default: null,
  },
  height: {
    default: null,
    hidden: true
  },
  chartSpan: {
    default: 24
  },
  chartResample: {
    default: 'hours'
  },
  yMax: {
    default: undefined
  },
  yMin: {
    default: undefined
  },
  markdownText: {
    default: ''
  },
  src: {
  },
  srcPath: {
  },
  label: {
    default: ''
  },
  dividerType: {
    default: 'blank'
  },
  showInSummary: {
    default: false,
    hidden: true
  },
  hideInDiagram: {
    default: false,
    hidden: true
  },
  hideInParentDiagram: {
    default: false,
    hidden: true
  },
  hideInEquipmentDetail: {
    default: false,
    hidden: true
  },
  hideInParentEquipmentDetail:{
    default: false,
    hidden: true
  },
  hideOnMap: {
    default: false,
    hidden: true
  },
  helpText: {
    default: ''
  },
  writeGroupTitle: {
    default: '',
    hidden: true
  },
  permissionClasses: {
    default: [],
    hidden: true
  },
};

module.exports = Dataset;
